'use client';

import Link from 'next/link';
import { ParticleBackground } from '@/components/animations';
import { ArticleCard } from '@/components/article-card';
import { fetchAgents } from '@/lib/api';
import { useState, useEffect } from 'react';
import { Agent } from '@/lib/types';
import { ChevronRight, Home, Bot } from 'lucide-react';

export default function AgentsPage() {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadAgents() {
      try {
        const data = await fetchAgents();
        setAgents(data);
      } catch (error) {
        console.error('Failed to load agents:', error);
      } finally {
        setIsLoading(false);
      }
    }
    loadAgents();
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white relative overflow-hidden">
      <ParticleBackground />

      {/* 面包屑 */}
      <header className="relative z-10 border-b border-white/5 bg-[#0a0a0f]/50 backdrop-blur-sm">
        <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-sm">
            <Link href="/" className="flex items-center gap-1 text-gray-400 hover:text-white transition-colors">
              <Home className="h-4 w-4" />
              <span>首页</span>
            </Link>
            <ChevronRight className="h-4 w-4 text-gray-600" />
            <span className="text-purple-400 font-medium">智能体</span>
          </div>
        </div>
      </header>

      <main className="relative z-10 py-12 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 rounded-xl bg-purple-500/10 border border-purple-500/30">
              <Bot className="h-6 w-6 text-purple-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">AI智能体</h1>
              <p className="text-gray-400">企业AI应用场景与智能体实践</p>
            </div>
          </div>

          {isLoading ? (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="animate-pulse">
                  <div className="bg-white/5 rounded-2xl h-64" />
                </div>
              ))}
            </div>
          ) : agents.length > 0 ? (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {agents.map((item) => (
                <ArticleCard
                  key={item.id}
                  id={item.id}
                  title={item.name}
                  summary={item.description}
                  tags={item.tags}
                  view_count={item.use_count}
                  created_at={item.created_at}
                  href={`/agents/${item.id}`}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-gray-500 text-lg">暂无智能体</p>
              <Link href="/" className="inline-block mt-4 text-purple-400 hover:underline">
                返回首页
              </Link>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
